WiseMetering.Model.User = WiseMetering.Model.extend({
    urlRoot: '/users',

    sites: function() {
        if (this.get('administrator')) {
            return WiseMetering.zones.sites();
        }
        return WiseMetering.groups.reduce((sites, group) => {
            if (group.get('user_ids').includes(this.id)) {
                sites.add(group.sites().models);
            }
            return sites;
        }, new WiseMetering.Collection.Zones);
    },

    getInitialsName: function() {
        let initial = [];
        this.shortName().split(' ').forEach(name => initial.push(name.split('')[0]));
        return initial.join('').toUpperCase();
    },

    groups: function() {
        return WiseMetering.groups.reduce((groups, group) => {
            if (group.get('user_ids').includes(this.id)) {
                groups.add(group);
            }
            return groups;
        }, new WiseMetering.Collection.Groups);
    },

    isAdministrator: function() {
        return this.get('administrator');
    },

    isConfigUser: function() {
        return this.get('config');
    },

    isLoggedInUser: function() {
        return this.id === WiseMetering.currentUser.id;
    },

    isManager: function() {
        return this.get('manager');
    },

    isRoot: function() {
        return this.get('root');
    },

    isStandard: function() {
        return this.get('standard');
    },

    isSuperUser: function() {
        return this.get('superuser');
    },

    preferences: function() {
        return WiseMetering.userPreferences;
    },

    resetPassword: function(success, error) {
        const options = { error, success, type: 'PUT', url: this.url() + '/reset_password' };

        return Backbone.sync.call(this, null, this, options);
    },

    role: function() {
        if (this.get('administrator')) {
            return i18next.t('glossary.administrator');
        } else if (this.get('manager')) {
            return i18next.t('glossary.manager');
        } else {
            return i18next.t('glossary.user');
        }
    },

    shortName() {
        const names = this.get('name').split(' ');
        return names.length > 1 ? [names.shift(), names.pop()].join(' ') : names.shift();
    }
});
